module.exports = __webpack_public_path__ + "img/product_service17.02eabe60.png";